<!--
 * Path: src/features/browser/forms/color/ColorRead.vue
 * Task: Read-only display of a color field showing the hex value dynamically styled.
 * Update: Removed the bulky avatar preview. Replaced with a clean, colored chip.
-->
<template>
  <div class="px-2 pt-1 pb-2">
    <!-- Clean chip representation of the color -->
    <v-chip
      :color="modelValue || defaultColor"
      variant="flat"
      size="small"
      class="font-weight-medium text-white elevation-1 font-family-mono"
    >
      {{ (modelValue || defaultColor).toUpperCase() }}
    </v-chip>
  </div>
</template>

<script setup lang="ts">
interface Props {
  modelValue?: string;
  defaultColor?: string;
}

withDefaults(defineProps<Props>(), {
  modelValue: '',
  defaultColor: 'grey'
});
</script>

<style scoped>
.font-family-mono {
  font-family: monospace;
  letter-spacing: 0.5px;
}
</style>
